import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';

function LoginPage() {
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // Check for error query params on load (e.g., from a redirect failure)
    useEffect(() => {
        // We look for any 'error' parameter after a redirect attempt
        const redirectError = searchParams.get('error');
        if (redirectError) {
            // Display a generic message for any redirect failure
            setError('The ZamPass login failed. Please try again.');
            // Optional: Clean the URL query parameters after displaying the error
            // navigate('/login', { replace: true });
        }
    }, [searchParams, navigate]);

    const handleZamPassLogin = () => {
        // Redirect the browser to the Zampass sign-in flow
        window.location.href = '/zampass-signin';
    };
    
    // Tailwind classes are assumed for better styling but I will use inline styles as in the original file to maintain consistency.
    return (
        <div style={{ maxWidth: '400px', margin: '50px auto', padding: '30px', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)' }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                {/* Placeholder for Logo - assuming /img/logo.svg exists */}
                <img src="/img/logo.svg" alt="ZamPass Logo" height="80" style={{ verticalAlign: 'middle', marginBottom: '2px' }} />
                <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#333' }}>ZamPass Login</h2>
            </div>
            
            {error && <p style={{ color: '#991b1b', backgroundColor: '#fee2e2', border: '1px solid #fca5a5', padding: '12px', borderRadius: '4px', marginBottom: '20px', textAlign: 'center' }}>{error}</p>}

            <div style={{ marginBottom: '25px', textAlign: 'center', padding: '15px', backgroundColor: '#f0f9ff', border: '1px solid #e0f2fe', borderRadius: '4px' }}>
                <p style={{ color: '#0c4a6e', fontSize: '1rem' }}>
                    All users should login with their <strong style={{color: '#00A36C'}}>ZamPass digital identity</strong>. Please click below to login with ZamPass.
                </p>
            </div>

            {/* ZamPass Login Button */}
            <button 
                onClick={handleZamPassLogin} 
                onMouseEnter={e => e.target.style.background = '#00955f'} 
                onMouseLeave={e => e.target.style.background = '#00A36C'} 
                style={{ 
                    padding: '12px 15px', 
                    width: '100%', 
                    background: '#00A36C', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '4px', 
                    cursor: 'pointer', 
                    fontWeight: '600', 
                    fontSize: '16px', 
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    transition: 'background 0.2s ease' 
                }}
            >
                Login with ZamPass Digital ID
            </button>

            {/* <p style={{ textAlign: 'center', marginTop: '30px', fontSize: '0.9rem', color: '#555' }}>
                Don't have an account? <Link to="/register" style={{ color: '#00A36C', textDecoration: 'none', fontWeight: '500' }}>Register here</Link>
            </p> */}
        </div>
    );
}

export default LoginPage;
